export default __webpack_public_path__ + "static/media/yuryu-09.0dec6904.svg";